import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/locationSitemap/pageContext';

export const LocationSitemapErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Local sitemap page (error: ${error})`);
};
